// extracted by mini-css-extract-plugin
export default {"container":"Skills_container__cQLlJ","wrapper":"Skills_wrapper__Qx19v","heading":"Skills_heading__Ahk1V","listItems":"Skills_listItems__tuGD3"};